(() => {
  if (window.__homepageFloatingVideoInitialized) return;

  window.__homepageFloatingVideoInitialized = true;

  const selector = '[data-floating-video]';
  const floatingClass = 'is-floating';
  let videoWrappers = [];
  let ticking = false;

  const addVideoWrappers = (root = document) => {
    root.querySelectorAll(selector).forEach((videoWrapper) => {
      if (!videoWrappers.includes(videoWrapper)) {
        videoWrappers.push(videoWrapper);
      }
    });
  };

  const updateFloatingVideos = () => {
    videoWrappers = videoWrappers.filter((videoWrapper) => document.documentElement.contains(videoWrapper));

    videoWrappers.forEach((videoWrapper) => {
      const rect = videoWrapper.getBoundingClientRect();
      videoWrapper.classList.toggle(floatingClass, rect.bottom <= 0);
    });

    ticking = false;
  };

  const requestUpdate = () => {
    if (ticking) return;

    ticking = true;
    window.requestAnimationFrame(updateFloatingVideos);
  };

  const init = (root = document) => {
    addVideoWrappers(root);
    requestUpdate();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();

(() => {
  if (window.__homepageFaqInitialized) return;

  window.__homepageFaqInitialized = true;

  document.addEventListener('click', (event) => {
    const question = event.target.closest('.faq-question');
    if (!question) return;

    const item = question.closest('.faq-item');
    const accordion = question.closest('.faq-accordion');
    if (!item || !accordion) return;

    const shouldOpen = !item.classList.contains('is-open');

    accordion.querySelectorAll('.faq-item.is-open').forEach((openItem) => {
      openItem.classList.remove('is-open');
      openItem.querySelector('.faq-question')?.setAttribute('aria-expanded', 'false');
    });

    if (shouldOpen) {
      item.classList.add('is-open');
      question.setAttribute('aria-expanded', 'true');
    }
  });
})();
